import React from 'react';

const logo = process.env.PUBLIC_URL + '/img/eunsa-logo.png';

const bosniaFlag = (
    <svg className="ph-flag" viewBox="0 0 20 12" aria-hidden="true">
        <rect width="20" height="12" fill="#002395" />
        <polygon points="4,0 20,0 20,12" fill="#FECB00" />
        <g fill="#fff">
            <circle cx="7" cy="2" r="0.9" />
            <circle cx="9.5" cy="4" r="0.9" />
            <circle cx="12" cy="6" r="0.9" />
            <circle cx="14.5" cy="8" r="0.9" />
            <circle cx="17" cy="10" r="0.9" />
        </g>
    </svg>
);

const ukFlag = (
    <svg className="ph-flag" viewBox="0 0 60 30" aria-hidden="true">
        <clipPath id="ph-uk-clip"><rect width="60" height="30" /></clipPath>
        <g clipPath="url(#ph-uk-clip)">
            <rect width="60" height="30" fill="#012169" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
            <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
            <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
        </g>
    </svg>
);

const LANGS = [
    { code: 'bs', label: 'Bosanski', flag: bosniaFlag },
    { code: 'en', label: 'English', flag: ukFlag },
];

export const LOGIN_HREF = '/';

// prijavu pokrece helper iz index.js; href na korijen ostaje kao rezerva
export function startLogin(e) {
    if (typeof window.eunsaLogin === 'function') {
        e.preventDefault();
        window.eunsaLogin();
    }
}

// link je aktivan ako vodi na trenutnu stranicu; sidro (#) uvijek pripada trenutnoj stranici
function isActiveLink(href) {
    if (href.charAt(0) === '#') return true;
    const path = window.location.pathname.replace(/\/$/, '');

    return path === href.replace(/\/$/, '');
}

export default function PublicHeader({
    lang, onLangChange, links, loginLabel
}) {
    const [open, setOpen] = React.useState(false);
    const ref = React.useRef(null);

    React.useEffect(() => {
        function onDocClick(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    function choose(code) {
        onLangChange(code);
        setOpen(false);
    }

    return (
        <header className="public-header">
            <style>{`
                .public-header {
                    position: sticky; top: 0; z-index: 50;
                    backdrop-filter: blur(12px);
                    -webkit-backdrop-filter: blur(12px);
                    background: rgba(8, 12, 20, 0.6);
                    border-bottom: 1px solid var(--border);
                }
                .public-header .ph-inner {
                    max-width: 1160px; margin: 0 auto; padding: 0 24px;
                    display: flex; align-items: center; justify-content: space-between; gap: 16px; height: 70px;
                }
                .public-header .ph-brand { display: flex; align-items: center; text-decoration: none; cursor: pointer; }
                .public-header .ph-brand img { height: 72px; width: auto; border-radius: 10px; }
                .public-header .ph-actions { display: flex; align-items: center; gap: 30px; }
                .public-header .ph-nav { display: flex; gap: 30px; align-items: center; }
                .public-header .ph-nav a { color: var(--muted); text-decoration: none; font-size: 15px; font-weight: 500; transition: color .2s; }
                .public-header .ph-nav a:hover { color: var(--text); }
                .public-header .ph-nav a.ph-active { color: var(--blue-light); font-weight: 700; }
                @media (max-width: 760px) { .public-header .ph-nav { display: none; } }

                .public-header .ph-login {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: linear-gradient(120deg, #1d6ea4, var(--blue-light));
                    color: #fff; text-decoration: none;
                    padding: 9px 20px; border-radius: 100px;
                    font-size: 14px; font-weight: 700;
                    box-shadow: 0 8px 24px rgba(29,110,164,.35);
                    transition: transform .15s, box-shadow .2s;
                    white-space: nowrap;
                }
                .public-header .ph-login:hover { transform: translateY(-2px); box-shadow: 0 12px 30px rgba(90,161,216,.45); }
                .public-header .ph-login svg { width: 16px; height: 16px; }

                .public-header .ph-lang { position: relative; }
                .public-header .ph-lang-btn {
                    display: inline-flex; align-items: center; gap: 7px;
                    background: var(--card); color: var(--text); border: 1px solid var(--border);
                    border-radius: 100px; cursor: pointer; padding: 7px 12px;
                    font-family: inherit; font-size: 13px; font-weight: 600;
                    transition: border-color .2s, background .2s;
                }
                .public-header .ph-lang-btn:hover { border-color: rgba(90,161,216,.45); }
                .public-header .ph-globe { width: 17px; height: 17px; color: var(--blue-light); }
                .public-header .ph-chev { width: 13px; height: 13px; color: var(--muted); transition: transform .2s; }
                .public-header .ph-chev.open { transform: rotate(180deg); }

                .public-header .ph-lang-menu {
                    position: absolute; top: calc(100% + 8px); right: 0; min-width: 175px;
                    list-style: none; margin: 0; padding: 6px; z-index: 60;
                    background: #0d141f; border: 1px solid var(--border); border-radius: 12px;
                    box-shadow: 0 16px 40px rgba(0,0,0,.5);
                }
                .public-header .ph-lang-item {
                    display: flex; align-items: center; gap: 10px; width: 100%;
                    background: transparent; border: none; cursor: pointer; color: var(--muted);
                    font-family: inherit; font-size: 14px; font-weight: 500; padding: 9px 10px;
                    border-radius: 8px; text-align: left; transition: background .15s, color .15s;
                }
                .public-header .ph-lang-item:hover { background: rgba(255,255,255,.05); color: var(--text); }
                .public-header .ph-lang-item.active { color: var(--blue-light); }
                .public-header .ph-flag { height: 13px; width: auto; border-radius: 2px; display: block; flex-shrink: 0; }
            `}</style>

            <div className="ph-inner">
                <a className="ph-brand" href="/public/landing" aria-label="eUNSA">
                    <img src={logo} alt="eUNSA logo" />
                </a>

                <div className="ph-actions">
                    <nav className="ph-nav">
                        {links.map(link => (
                            <a
                                key={link.href}
                                href={link.href}
                                className={isActiveLink(link.href) ? 'ph-active' : ''}
                                aria-current={isActiveLink(link.href) ? 'page' : undefined}
                            >
                                {link.label}
                            </a>
                        ))}
                    </nav>

                    <a className="ph-login" href={LOGIN_HREF} onClick={startLogin}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                            <path d="M10 17l5-5-5-5M15 12H3" />
                        </svg>
                        {loginLabel}
                    </a>

                    <div className="ph-lang" ref={ref}>
                        <button
                            type="button"
                            className="ph-lang-btn"
                            onClick={() => setOpen(o => !o)}
                            aria-haspopup="listbox"
                            aria-expanded={open}
                        >
                            <svg className="ph-globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="9" />
                                <path d="M3 12h18" />
                                <path d="M12 3c2.5 2.6 3.8 5.8 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.8-3.8-9s1.3-6.4 3.8-9Z" />
                            </svg>
                            <span className="ph-lang-code">{lang.toUpperCase()}</span>
                            <svg className={'ph-chev' + (open ? ' open' : '')} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M6 9l6 6 6-6" />
                            </svg>
                        </button>

                        {open && (
                            <ul className="ph-lang-menu" role="listbox">
                                {LANGS.map(l => (
                                    <li key={l.code}>
                                        <button
                                            type="button"
                                            className={'ph-lang-item' + (lang === l.code ? ' active' : '')}
                                            onClick={() => choose(l.code)}
                                            role="option"
                                            aria-selected={lang === l.code}
                                        >
                                            {l.flag}
                                            <span>{l.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
}



// WEBPACK FOOTER //
// ./src/views/Public/PublicHeader.js